/**
 * InputsDataRow — Attributed data row for InputsPill expanded panel
 *
 * Shows source dot, label, optional note, and right-aligned value.
 */

import type { InputSource } from './SourceCircle';
import { SOURCE_CONFIG } from './SourceCircle';

const CHARCOAL = '#1A1A1A';
const FONT = "'Manrope', 'Inter', -apple-system, sans-serif";

interface InputsDataRowProps {
  label: string;
  value: string;
  source: InputSource;
  note?: string | null;
  divider?: boolean;
}

export function InputsDataRow({ label, value, source, note, divider = true }: InputsDataRowProps) {
  const dot = SOURCE_CONFIG[source].color;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8,
      padding: '10px 0',
      borderBottom: divider ? '1px solid #F8F8F7' : 'none',
      fontFamily: FONT,
    }}>
      {/* Source dot */}
      <div style={{
        width: 6, height: 6, borderRadius: '50%',
        backgroundColor: dot, flexShrink: 0,
      }} />

      {/* Label + note */}
      <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'baseline', gap: 6 }}>
        <span style={{ fontSize: 13, color: '#57534E' }}>{label}</span>
        {note && (
          <span style={{ fontSize: 10, color: '#B8B0A8', fontStyle: 'italic' }}>{note}</span>
        )}
      </div>

      {/* Value */}
      <span style={{
        fontSize: 13, fontWeight: 600, color: CHARCOAL,
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}>{value}</span>
    </div>
  );
}
